export default class TypRozpisuService {

  constructor(server){
    this.server = server;
  }

  list(){
    return this.server("TypRozpisu.list").then(r => r.result);
  }

  save(item){
    return this.server("TypRozpisu.create", {nazov: item.nazov, rola: item.rola});
  }

  update(item){
    return this.server("TypRozpisu.update", {id: item.id, nazov: item.nazov, rola: item.rola}); 
  }

  remove(item){
    return this.server("TypRozpisu.delete", {id: item.id});
  }


}


// WEBPACK FOOTER //
// ./src/services/TypRozpisuService.js